import { createClient } from '@supabase/supabase-js';

// Récupération des variables d'environnement
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validation
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Les variables VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY doivent être définies dans .env.local'
  );
}

// Création du client Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types pour les tables (synchronisés avec la BDD)
export interface Restaurant {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  location: string | null;
  address: any | null;
  website: string | null;
  phone: string | null;
  email: string | null;
  cuisine: string[] | null;
  price_range: string | null;
  established: number | null;
  status: 'active' | 'paused' | 'churned' | 'prospect';
  pack: 'essentiel' | 'premium' | 'signature' | null;
  contract_start_date: string | null;
  contract_end_date: string | null;
  monthly_revenue: number | null;
  primary_contact: any | null;
  billing_info: any | null;
  settings: any;
  rcs: string | null;
  siret: string | null;
  created_at: string;
  updated_at: string;
}

export interface RestaurantMetrics {
  id: string;
  restaurant_id: string;
  period_start: string;
  period_end: string;
  seo_data: {
    domain_authority: number;
    backlinks_count: number;
    organic_keywords: number;
    organic_traffic: number;
    position_average: number;
    visibility_score: number;
  } | null;
  geo_data: {
    google_my_business: boolean;
    citations: number;
    reviews: number;
    average_rating: number;
    local_pack_rankings: number;
  } | null;
  language_coverage: {
    fr: number;
    en: number;
    es: number;
    pt: number;
  } | null;
  traffic_by_country: any | null;
  search_intents: any[] | null;
  brand_metrics: any | null;
  created_at: string;
  updated_at: string;
}

// Type pour la vue dashboard_kpis
export interface DashboardKPI {
  id: string;
  name: string;
  slug: string;
  organic_visibility: number | null;
  backlinks: number | null;
  review_count: number | null;
  average_rating: number | null;
  language_coverage: {
    fr: number;
    en: number;
    es: number;
    pt: number;
  } | null;
}

// Types pour audit_items
export interface AuditItem {
  id: string;
  restaurant_id: string;
  category: 'technique' | 'semantique' | 'local';
  subcategory: string | null;
  title: string;
  description: string | null;
  url: string | null;
  priority: 'P0' | 'P1' | 'P2';
  impact: number;
  confidence: number;
  effort: number;
  ice_score: number;
  status: 'todo' | 'in_progress' | 'completed' | 'blocked';
  assignee: string | null;
  due_date: string | null;
  completed_date: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

